import { FatalDecoratorLimitDescriptorError } from '@rehaje/reactive'
import {
  createMemberDecorator,
  ensureProtoProps,
  isInheritProto
} from '@rehaje/shared'

import { DefaultExposedKeys } from '../constants'
import { ViewModel } from '../models/ViewModel'

import type { MixtureMemberDecorator } from '@rehaje/shared'

/**
 * 声明 getExposedViewModel 可暴露的 API，默认都不暴露
 * @example
 * // jsdoc 限制，实际使用请将 * 替换为 @
 * class MyNode extends TypedNode {
 *   *fromSpecific()
 *   *reactive()
 *   test = 123 //默认不暴露
 *
 *   *exposed() //暴露
 *   test1 = 231
 * }
 */
export const exposed: () => MixtureMemberDecorator = createMemberDecorator({
  tsDecorator(proto: ViewModel, key, descriptor) {
    if (!isInheritProto(proto, ViewModel.prototype)) {
      throw new FatalDecoratorLimitDescriptorError('exposed', key, 'ViewModel')
    }

    const exposedKeys = ensureProtoProps(
      proto,
      '__r_exposed_keys',
      DefaultExposedKeys
    )
    if (!exposedKeys.includes(key)) exposedKeys.push(key)

    return descriptor
  }
})
